export default "__VITE_ASSET__BmLwb8PW__"